export default __webpack_public_path__ + "static/media/Package.49a39c5c.svg";